// Filtros em pílula ("All / Unfulfilled / Processing" da referência). Rola na horizontal no
// celular em vez de quebrar linha.
export const SegmentedTabs = ({ tabs, value, onChange }) => (
  <div className="-mx-1 flex max-w-full gap-1 overflow-x-auto px-1 py-0.5">
    {tabs.map((tab) => {
      const active = tab.key === value;
      return (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          className={`inline-flex flex-shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg px-3 py-1.5 text-[13px] font-medium transition ${
            active ? 'bg-accent text-white shadow-sm' : 'bg-white text-gray-700 shadow-pill hover:bg-gray-50'
          }`}
        >
          {tab.label}
          {tab.count !== undefined && (
            <span className={`tabular rounded-md px-1.5 text-[11px] ${active ? 'bg-white/20 text-white' : 'bg-gray-100 text-gray-500'}`}>
              {tab.count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);
